import React from 'react';
import autobind from 'autobind';
import { observer, inject } from 'mobx-react';
import { v4 as uuid } from 'uuid';

import { ContactPersonList, ContactPersonListParams } from './ContactPersonList';
import { ehrService } from '@patient/services/ehr/ehrService';
import { ProfileForm } from '@profile/store/ProfileForm';
import { AppState } from '@store/App/App';

interface Props extends ContactPersonListParams {}

interface StoreProps {
    profileForm: ProfileForm;
    app: AppState;
}

@observer
class Component extends React.Component<Props & StoreProps> {
    public render(): React.ReactNode {
        const { profileForm } = this.props;

        const contactPersonIds = profileForm.getContactPersonIds();

        return React.createElement(ContactPersonList, {
            contactPersonIds,
            onUpdateContactPerson: this.handleUpdateContactPersons,
        });
    }

    @autobind
    protected async handleUpdateContactPersons() {
        const { app } = this.props;
        const reqId = uuid();

        app.addSaveRequest(reqId);

        await ehrService.updateContactPersons();

        app.removeSaveRequest(reqId);
    }
}

export const ContactPersonListContainer = inject<Props, StoreProps>(ProfileForm.Name, AppState.Name)(Component);
